import {
  GET_LIST_DANHSACHKHO,
  GET_LIST_DANHSACHKHO_SUCCESS,
  GET_LIST_DANHSACHKHO_FAILURE,
} from 'actions/DanhSachKho/actionTypes';

const initialState = {
  getListDanhSachKhoLoading: false,
  posts: [],
  objList: [],
  totalRow: 0,
};

const getListDanhSachKho = (state, action) => ({
  ...state,
  getListDanhSachKhoLoading: true,
});

const getListDanhSachKhoSuccess = (state, action) => {
  return {
    ...state,
    getListDanhSachKhoLoading: false,
    objList: action.payload,
  };
};

const getListDanhSachKhoFailed = (state, action) => ({
  ...state,
  getListDanhSachKhoLoading: false,
  objList: [],
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHKHO:
      return getListDanhSachKho(state, action);
    case GET_LIST_DANHSACHKHO_SUCCESS:
      return getListDanhSachKhoSuccess(state, action);
    case GET_LIST_DANHSACHKHO_FAILURE:
      return getListDanhSachKhoFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
